import React from 'react';
import { MIcon } from '../../lib/micon';

interface Props {
  naechstes_sj: string;
  onStart: () => void;
}

export function HardCutoffModal({ naechstes_sj, onStart }: Props) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{
        background: 'white', borderRadius: 'var(--ld-radius-2xl)',
        maxWidth: 440, width: '100%',
        padding: '36px 32px',
        boxShadow: '0 24px 80px rgba(0,0,0,0.35)',
        textAlign: 'center',
      }}>
        <div style={{ marginBottom: 16, color: 'var(--ld-warning-text)' }}><MIcon name="event_upcoming" size={48} /></div>
        <h2 style={{ fontSize: 22, fontWeight: 800, margin: '0 0 12px', color: 'var(--ld-text-primary)' }}>
          Schuljahres-Wechsel erforderlich
        </h2>
        <p style={{ fontSize: 14, color: 'var(--ld-text-secondary)', lineHeight: 1.6, margin: '0 0 8px' }}>
          Das neue Schuljahr <strong>{naechstes_sj}</strong> hat begonnen. Bevor du LehrerDesk
          weiternutzen kannst, müssen deine Klassen aktualisiert werden.
        </p>
        <p style={{ fontSize: 13, color: 'var(--ld-text-secondary)', lineHeight: 1.5, margin: '0 0 28px' }}>
          Dies dauert etwa 5–15 Minuten und sichert deine Anker-Noten für Zeugnisberechnungen.
        </p>
        <button
          onClick={onStart}
          style={{
            width: '100%', padding: '15px 0', borderRadius: 'var(--ld-radius-lg)', border: 'none',
            background: 'var(--ld-primary)', color: 'white', fontSize: 16, fontWeight: 700, cursor: 'pointer',
          }}
        >
          Übergangs-Wizard starten →
        </button>
      </div>
    </div>
  );
}
